import React, { useState, useEffect } from 'react'
import { Button, Row, Panel, Message, Checkbox } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { DEFAULT_ERR_MSG, RETRY_CONTACT_ADMIN } from '../../constants/msgText'
import { SUB_PROJECT_ID } from '../../constants/constants'
import { sessionGetItemStr } from '../../utils/sessionHelpers'
import { getSubProjectSubmitPdf, submitSubProject } from '../../redux/actions/subProjectManage'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { setAlertMessage } from '../../utils/messageUtil'
import { getSubProjectPDPA } from '../../redux/actions/projectOverview'

export default function SubProjectSubmitProposl({
  schema,
  //finalSubmitButtonText = 'ยืนยันการยื่นข้อเสนอโครงการ',
  ...props
}) {
  const history = useHistory()

  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [showModalFinalConfirm, setShowModalFinalConfirm] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [PDPASchema, setPDPASchema] = useState()
  const [acceptPDPA, setAcceptPDPA] = useState()
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  useEffect(() => {
    handleGetProjectSubmitPdf()
  }, [subProjectId])

  const handleGetProjectSubmitPdf = async () => {
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await getSubProjectSubmitPdf(subProjectId)
      //console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.error('error => ', e)
      setIsPdfError(true)
    }
    setIsLoadingPDF(false)
    setShowModalFinalConfirm(false)
  }

  const handleProposalProjectSubmitConfirm = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setShowModalFinalConfirm(false)
    try {
      //  call API
      const response = await submitSubProject(subProjectId)
      if (response) {
        history.push({
          pathname: `${pathname.subProject.overviewSubProject}`,
        })
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log(e)

      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
    setShowModalFinalConfirm(false)
  }

  // const handleGetPDPA = async () => {
  //   setIsLoading(true)
  //   startLoading()
  //   try {
  //     const response = await getSubProjectPDPA(subProjectId, null, 1)
  //     if (response?.forms?.pdpa) {
  //       setPDPASchema(response?.forms?.pdpa)
  //     }
  //     setShowModalFinalConfirm(true)
  //   } catch (e) {
  //     console.log('e', e)
  //     setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
  //   }
  //   doneLoading()
  //   setIsLoading(false)
  // }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded header={schema.header}>
        {isError && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="error" description={DEFAULT_ERR_MSG} />
          </Row>
        )}
        <Button
          block
          style={{ minWidth: 200, maxWidth: 350 }}
          color="rgb(45, 168, 136)"
          appearance="primary"
          disabled={isLoading || schema.disabled}
          // onClick={() => handleGetPDPA()}
          onClick={() => setShowModalFinalConfirm(true)}
        >
          {schema?.sendButton || 'ยืนยันการยื่นข้อเสนอโครงการ'}
        </Button>
        <hr />

        {isPdfError ? (
          <Message showIcon type="error" description={'ไม่พบไฟล์ PDF  ' + RETRY_CONTACT_ADMIN} />
        ) : (
          <>
            {!schema.disabled && (
              <PdfRenderWidgets
                file={previewPdf}
                isLoading={isLoadingPDF}
                isShaded={false}
                onReload={() => handleGetProjectSubmitPdf()}
                loadingMessage="กรุณารอสักครู่ ระบบกำลังสร้าง PDF ข้อเสนอโครงการ..."
                firstExpandToReload
              />
            )}
          </>
        )}
      </Panel>


      

      <ConfirmWidget
        title={`ยืนยัน`}
        //size="md"
        show={showModalFinalConfirm}
        // detail={`${schema?.sendButton || 'ยืนยันการยื่นข้อเสนอโครงการ'}`}
        // disabled={!acceptPDPA && !schema.skipPDPA}
        detail={
          <>
            <div style={{ marginLeft: 5, marginRight: 5 }}>
              <p>{`${schema?.sendButton || 'ยืนยันการยื่นข้อเสนอโครงการ'}`}</p>

              {/* {!schema.skipPDPA && PDPASchema && (
                <>
                  {PDPASchema?.message}
                  <Button
                    block
                    color="blue"
                    style={{ minWidth: 200, marginTop: 20 }}
                    appearance="primary"
                    disabled={isLoading}
                    onClick={() => {
                      if (PDPASchema?.url) {
                        window.open(PDPASchema?.url, '_blank')
                      } else {
                        notification.open('error', {
                          title: 'ไม่พบ URL อ่านรายละเอียด PDPA',
                          duration: 5000,
                        })
                      }
                    }}
                  >
                    {PDPASchema?.readPdpa}
                  </Button>
                  <Checkbox
                    style={{ marginTop: 20 }}
                    checked={acceptPDPA}
                    onChange={(_, check) => {
                      setAcceptPDPA(check)
                    }}
                  >
                    {PDPASchema?.checkbox}
                  </Checkbox>
                </>
              )} */}
            </div>
          </>
        }
        onCancle={() => setShowModalFinalConfirm(false)}
        onConfirm={handleProposalProjectSubmitConfirm}
      />
    </>
  )
}
